import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Изменение КМ',
      title: 'Изменение КМ',
      executeAction: 'Отправить',
      errorMessage: 'Ошибка',
      successMessage: 'Запрос успешно отправлен',
      fields: {
      },
    }
  }
}